import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Price.scss';
import language from "@lang/language";

const PriceC = ({priceData, color = ''}) => {
	if (!priceData) {
		return null;
	}

	return (
	  <div className={`${styles.container} ${styles.baseLine} ${styles.sizeBodyText} ${color ? styles[color] : ''}`}>
		  <div className={styles.priceFrom}>
			  {language.from}
		  </div>

		  <div className={styles.prices}>
			  <div className={`${styles.priceContainer} ${styles.baseLine}`}>
				  <div className={`${styles.price} ${styles.sizeBodyText}`}>
					  {priceData.price}
				  </div>
				  <div>
					  {priceData.text}
				  </div>
			  </div>
		  </div>
	  </div>
	);
}

PriceC.propTypes = {
	priceData: PropTypes.object.isRequired,
	color: PropTypes.string
};

export default PriceC;
